import headlinePicture from '../../assets/zdrowy-rozwoj-twojego-dziecka.png';
import contentPicture from '../../assets/wspieraj-niezaklocony-rozwoj-twojej-pociechy.jpg';


export const DATA = {
  headline: {
    photo: {
      xs: {
        src: headlinePicture,
        width: 700,
        height: 583
      },
      alt: 'Zdrowy rozwój Twojego dziecka'
    },
    heading: 'Zdrowy rozwój Twojego dziecka.',
    description: 'Poznaj naukowo sprawdzone metody wychowywania naszych pociech, zabawki wspierające kompleksowy rozwój i rzetelne informacje o zdrowiu i profilaktyce.'
  },

  categories: {
    heading: 'Odpowiedzi na wielkie i małe pytania rodziców',
    description: 'Chcemy uzbroić wszystkich rodziców w rzetelną wiedzę o zdrowiu i rozwoju dzieci. Przekazujemy informacje i porady oparte o sprawdzone badania naukowe. Pomożemy Ci obrać właściwą drogę w fascynującym labiryncie rodzicielstwa!',
    icon: 'markFlag',
    flagIconSize: {
      height: '7.2rem'
    },
    items: [
      {
        title: 'Ciąża',
        description: 'Dowiedz się, czego się spodziewać, tydzień po tygodniu, wraz z rozwojem małego człowieka w Twoim ciele. Przeczytaj jak sprawić, żeby ten magiczny czas upłynął w poczuciu bezpieczeństwa.',
        icon: 'pregnancy',
        iconSize: {
          height: '6.3rem'
        },
        url: '/pl/ciaza'
      },
      {
        title: 'Zdrowie',
        description: 'Jak dbać o zbilansowaną dietę – Twoją i Twojego malucha? Jakie niepokojące objawy powinny zwrócić Twoją uwagę? Co zrobić, żeby zapobiegać powszechnym dolegliwościom?',
        icon: 'health',
        iconSize: {
          height: '4.3rem'
        }
      },
      {
        title: 'Wychowanie',
        description: 'Podpowiadamy jak stworzyć zdrową i pełną miłości relację z Twoim dzieckiem. Obalamy szkodliwe mity o wychowaniu. W końcu – dzielimy się najciekawszymi propozycjami rozwojowych zabaw i gier.',
        icon: 'upbringing',
        iconSize: {
          height: '5.6rem'
        },
        url: '/pl/wychowanie'
      },
      {
        title: 'Zabawki',
        description: 'Recenzje najlepszych zabawek, które pomogą wspierać rozwój Twojej pociechy na każdym etapie życia. Proponujemy wyłącznie zabawki, które spełniają listę naszych wymagających kryteriów.',
        icon: 'toys',
        iconSize: {
          height: '5.8rem'
        },
        url: '/pl/zabawki'
      },
      {
        title: 'Meble',
        description: 'Wyjaśniamy jak przygotować dom na przybycie nowego lokatora i w co wyposażyć przestrzeń w miarę jego rozwoju. Łóżeczka, krzesła do karmienia, meble do pokoju dziecięcego – nie mają przed nami tajemnic!',
        icon: 'furniture',
        iconSize: {
          height: '6.9rem'
        },
        url: '/pl/meble'
      },
      {
        title: 'Wózki',
        description: 'Dzięki naszym poradom znajdziesz wózek, który posłuży Ci przez lata (a nawet – pokolenia!). Znajdziesz tu wózki na każdą okazję, okoliczność i potrzebę, wyselekcjonowane na podstawie doświadczeń innych rodziców.',
        icon: 'accessories',
        iconSize: {
          height: '4.9rem'
        },
        url: '/pl/wozki'
      },
      {
        title: 'Ubranka',
        description: 'Podpowiadamy co wybrać, aby ubrania pomagały, a nie przeszkadzały, naszym pociechom w eksploracji otaczającego je świata. Dowiesz się, na co zwracać uwagę przy doborze garderoby Twojej pociechy i gdzie znajdziesz najlepsze ubrania.',
        icon: 'accessories',
        iconSize: {
          height: '4.9rem'
        },
        url: '/pl/ubranka'
      }
    ]
  },

  content: {
    heading: 'Twój niezbędnik rodzica',
    description: 'Nasz zespół ekspertów będzie Cię wspierał na każdym etapie Twojej rodzicielskiej podróży: od ciąży, przez wiek niemowlęcy i wczesne dzieciństwo, aż do lat szkolnych.',
    list: [
      'Recenzje',
      'Kalkulatory',
      'Kalendarze',
      'Poradniki'
    ],
    picture: {
      xs: {
        src: contentPicture,
        width: 605,
        height: 766
      },
      alt: 'Wspieraj niezakłócony rozwój Twojej pociechy'
    },
    hasPictureOnTheLeft: false
  },

  news: {
    heading: 'Przeczytaj najnowsze artykuły',
    description: 'Nasi eksperci służą pomocą Tobie i Twoim dzieciom. Zobacz treści, które dla Ciebie przygotowaliśmy',
    icon: 'markFlag',
    isDark: false
  }
};
